import axios from "axios";
import { encryptedAuth } from "../../Services/EncryptData";
import { deleteUnblockedcourt, getDisablecourt } from "../../Services/BackendUrl";

export const getDisabledCourts = () => {
    return axios.get(getDisablecourt, {
        headers: { "Content-Type": "application/json",
        Authorization: `Encrypted ${encryptedAuth}` },
    })
};

export const unBlockCourts = (data) => {
    return axios.delete(deleteUnblockedcourt, {
        data,
        headers: { "Content-Type": "application/json",
        Authorization : `Encrypted ${encryptedAuth}` },
    });
};
